export default __webpack_public_path__ + "static/media/office1-before1-768w.04d0bc2b.png";